module.exports = __webpack_public_path__ + "img/backpic.af51aac2.svg";